/* global axios */

import ApiClient from '../ApiClient';

class VivacrmVisionAPI extends ApiClient {
  constructor() {
    super('integrations/vivacrm_vision', { accountScoped: true });
  }

  getTags() {
    return axios.get(`${this.url}/tags`);
  }

  getTickets({ tagIds, statusOrderType = 'byCreateDate', pageSize = 20 } = {}) {
    return axios.post(`${this.url}/tickets`, {
      tag_ids: tagIds || [],
      status_order_type: statusOrderType,
      page_size: pageSize,
    });
  }
}

export default new VivacrmVisionAPI();
